import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import Service from './util/request'

import vueCookie from 'vue-cookies';
import MintUI from 'mint-ui'
// import VueCookies from 'vue-cookies'
import 'mint-ui/lib/style.css'
import 'swiper/swiper-bundle.css'
import vueSwiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2'

import './util/flex'

import "./assets/styles/common.css";

import * as filters from './util/filters.js'
Object.keys(filters).forEach(key=>{
    Vue.filter(key,filters[key])
})

Vue.use(MintUI)
Vue.use(vueSwiper)
Vue.use(vueCookie)
Vue.use(VueClipboard)
Vue.prototype.baseApi = Service;


let siteConfig = {
  "loginLogoPath":"shjr"
}

//TODO 添加配置文件
Vue.prototype.siteConfig = siteConfig;



new Vue({
    router,
  render: h => h(App),
}).$mount('#app')
